interface CloudflareTurnstileResponse {
  success: boolean;
  'error-codes'?: string[];
  challenge_ts?: string;
  hostname?: string;
}

/** Client-side Turnstile token verification via `/api/cloudflare-captcha`. */
export async function validateTurnstile(token: string): Promise<boolean> {
  const {
    public: { internalAPI },
  } = useRuntimeConfig();

  const endpoint = internalAPI?.turnstile || '/api/cloudflare-captcha';

  try {
    const response = await $fetch<CloudflareTurnstileResponse>(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: { token },
    });

    return response.success ?? false;
  } catch {
    return false;
  }
}
